import { createFileRoute } from '@tanstack/react-router'
import { ListingEditor } from '../../../components/listings/ListingEditor'

export const Route = createFileRoute('/$org/listings/$listingUid')({
  component: ListingEditor,
})
